import { AfterViewChecked, Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { Address, UpsCacComponent, WidgetOptions } from "@ews/cac";
import { LocationDetailsSession } from "../../../api/models/locationDetailsSession";
import { ApiErrorCode, CAC_FIELD_TYPE_ERROR, CommonConstants, CONTINENTAL_REGIONS, COUNTRY_LANGUAGE, ServiceURLConstants } from "../../../constants/upplm.constants";
import { AvailableDayAndService, GetPickupScheduleDetailsRequest, PickupScheduleDetailResponse, PreferredOptions } from "../../../interface/upplm.pickupdetails";
import { TranslateDataPipe } from "../../../pipes/translation.pipe";
import { LocationDetailsHelperService } from "../../../services/PlacardEditionServices/upplm.locationDetailsHelper.service";
import { PickupDetailsHelperService } from "../../../services/PlacardEditionServices/upplm.pickupDetailsHelper.service";
import { UpplmApiService } from "../../../services/upplm.api.services";
import { UpsCommonService } from "../../../services/upplm.common.service";
import { StoredDataService } from "../../../services/upplm.storedData.service";
import { UpsDialogComponent } from "../../commonComponent/ups-dialog/ups-dialog.component";

@Component({
    selector: 'editlocationdetails',
    template: require('./editLocationDetails.component.html'),
    providers: [LocationDetailsHelperService]
})

export class EditLocationDetailsComponent implements OnInit, AfterViewChecked {
    cacOptions: WidgetOptions = new WidgetOptions();
    @ViewChild(UpsCacComponent, { static: false })
    cacComponentForEdition: UpsCacComponent;
    isLoading: boolean = false;
    showNotificationChanges: boolean = false;
    showEditPickupDetails: boolean = false;
    showEditLocationDetails: boolean = true;
    @Output() hideEditSection = new EventEmitter<boolean>();
    errors: any[] = [];
    isAmbiguosAddress: boolean = true;
    addressError: string = '';
    editedAddress: Address = new Address();
    messagesErrorServer: string = '';
    availableDaysAndServices: AvailableDayAndService[] = [];
    pickupPlanType: string = '';
    @ViewChild('errorServerMessage', { static: false }) errorServerMessage: UpsDialogComponent;


    constructor(private _storedDataService: StoredDataService,
        private _locationDetailsHelperService: LocationDetailsHelperService,
        private _translate: TranslateDataPipe,
        private _pickupDetailsHelperService: PickupDetailsHelperService,
        private _commonService: UpsCommonService,
        private _apiService: UpplmApiService) {
    }
    ngAfterViewChecked(): void {
        const countryDropDown = document.getElementsByClassName('ups-dropdown ng-untouched ng-pristine ng-valid');
        if (countryDropDown.length > 0) {
            countryDropDown[0].setAttribute('disabled', 'true');
        }
        if (this._commonService.locale === 'en_GB') {
            this.cacComponentForEdition.cityFieldState.label = 'City';
        }
    }

    ngOnInit(): void {
        this.initializeCac(this._storedDataService.locationDetails);
    }

    initializeCac(data: LocationDetailsSession) {
        this.cacOptions = this._locationDetailsHelperService.getCACOptions();
        if (this._commonService.isEmeaCountry(data.countryKey)) {
            this.setValueForCountryChange(false, false, data.countryKey, data.countryKey);
        } else {
            this.setValueForCountryChange(true, false, data.countryKey, data.countryKey);
        }

        setTimeout(() => {
            this.cacComponentForEdition.init(this.cacOptions).subscribe((response: any) => {
                this.bindDataFromStoredData(data);
            });
        });
    }

    onCountryChange() {
        if ((COUNTRY_LANGUAGE.find(x => x.key === this.cacComponentForEdition.country.key).region) === CONTINENTAL_REGIONS.EMEA) {
            this.setValueForCountryChange(false, false, this.cacComponentForEdition.country.key, this.cacComponentForEdition.country.value);
        } else {
            this.setValueForCountryChange(true, false, this.cacComponentForEdition.country.key, this.cacComponentForEdition.country.value);
        }
    }

    setValueForCountryChange(showState: boolean, showInputState: boolean, countryKey: string, CountryValue: string) {
        this.cacOptions.showStateInput = function () {
            return showInputState;
        }
        this.cacOptions.showState = function () {
            return showState;
        }
        this.cacOptions.address.country.key = countryKey;
        this.cacOptions.address.country.value = CountryValue;
    }

    bindDataFromStoredData(data: LocationDetailsSession) {
        this.cacComponentForEdition.country = this.cacOptions.countries.filter(k => k.key == data.countryKey)[0];
        this.cacComponentForEdition.name = data.companyName;
        this.cacComponentForEdition.postal = data.postal;
        this.cacComponentForEdition.address1 = data.address1;
        this.cacComponentForEdition.city = data.city;
        this.cacComponentForEdition.state = data.state;
    }

    saveEdit() {
        this.errors = [];
        this.cacComponentForEdition.formValid();
        this.displayCacErrors();
        if (this.errors.length === 0) {
            if (this.cacComponentForEdition.isFormValid()) {
                this.isLoading = true;
                this.validateCacAddress();
            }
        }
    }

    displayCacErrors() {
        this.cacComponentForEdition.getFormErrors().forEach(errorRow => {
            if (!errorRow.type.includes('info') && !errorRow.type.includes('sysErr')) {
                this.errors = this.errors.concat(this.addError(errorRow.id, `${this._translate.transform(CAC_FIELD_TYPE_ERROR.find(x => x.id === errorRow.type && x.field === errorRow.fieldName).key)}`, errorRow.type));
            } else {
                this.errors = this.errors.concat(this.addError(errorRow.id, errorRow.displayText, ''));
            }
        });
        if (this.isDifferentCountry()) {
            this.errors = this.errors.concat(this.addError('country', this._translate.transform('upplm.cac.error.common.countryisdifferent'), 'customError'));
        }
    }

    focusInput(item: any) {
        document.getElementById(item.id).focus();
    }

    addError(id: string, field: string, condition: string): any {
        return [{
            "id": id,
            "displayText": field,
            "type": condition,
            "fieldName": "Name",
            "fieldError": "Name error",
            "fieldErrorDescription": "field Error"
        }];
    }

    isDifferentCountry(): boolean {
        if (this._storedDataService.locationDetails.countryKey !== this.cacComponentForEdition.country.key.toString()) {
            return true;
        }
        return false;
    }

    validateCacAddress() {
        this.isLoading = true;
        this.cacComponentForEdition.validateAddress().subscribe(response => {
            if (response.validationResult.key === CommonConstants.VALIDATION_RESULT_KEY_2
                || response.validationResult.key === CommonConstants.VALIDATION_RESULT_KEY_0
                || response.validationResult.key === CommonConstants.VALIDATION_RESULT_KEY_1) {
                //Invalid Address                     
                if (response.validationResult.key === CommonConstants.VALIDATION_RESULT_KEY_0 ||
                    response.validationResult.key === CommonConstants.VALIDATION_RESULT_KEY_2) {
                    this.isLoading = false;
                    this.proceedToNotificationSection();
                } else { //ambiguos, first click, it should be in the same page and allow select any sugested address
                    if (this.isAmbiguosAddress) {
                        this.isAmbiguosAddress = false;
                        this.isLoading = false;
                    } else { //Two clicks on next it must allow to go to next page                                    
                        this.isLoading = false;
                        this.proceedToNotificationSection();
                    }
                }
            }
        });
    }

    proceedToNotificationSection() {
        this.bindCacDataToSave();
        if (this._locationDetailsHelperService.locationHasChanges(this.editedAddress,
            this._storedDataService.locationDetails)) {
            this.CallingLocationServices();
        } else {
            this.storeDataInSession();
            this._storedDataService.requestEditedData = this._locationDetailsHelperService.prepareSaveEditionRequest(
                this.editedAddress, this._storedDataService.locationDetailsTransitSession.companyName);
            this.showNotificationComponent(true);
        }
    }

    bindCacDataToSave() {
        this.editedAddress.address1 = this.cacComponentForEdition.address1;
        this.editedAddress.city = this.cacComponentForEdition.city;
        this.editedAddress.country.key = this.cacComponentForEdition.country.key;
        this.editedAddress.state = this.cacComponentForEdition.state;
        this.editedAddress.postal = this.cacComponentForEdition.postal;
    }

    storeDataInSession() {
        // Store to session
        let locationDetailsTransitSession = new LocationDetailsSession();
        locationDetailsTransitSession.address1 = this.editedAddress.address1;
        locationDetailsTransitSession.city = this.editedAddress.city;
        locationDetailsTransitSession.countryKey = this.editedAddress.country.key;
        locationDetailsTransitSession.state = this.editedAddress.state.key;
        locationDetailsTransitSession.postal = this.editedAddress.postal;
        locationDetailsTransitSession.companyName = this.cacComponentForEdition.name;
        this._storedDataService.locationDetailsTransitSession = locationDetailsTransitSession;
    }

    cancel() {
        this._storedDataService.clearEditingSections();
        this.hideEditSection.emit(true);
    }

    hideNotificationChange(showNotificationComponent: boolean) {
        this.showNotificationComponent(showNotificationComponent);
        if (this._storedDataService.isEditionComplete) {
            this.cancel();
        } else {
            this.initializeCac(this._storedDataService.locationDetailsTransitSession);
        }
    }

    hideSection(showEditPickupComponent: boolean) { // Hide Pickup Details component and reload CAC
        this.showEditPickupDetailComponent(showEditPickupComponent);
        this.initializeCac(this._storedDataService.locationDetailsTransitSession);
    }

    showNotificationComponent(show: boolean) {
        this.showNotificationChanges = show;
        this.showEditLocationDetails = !show;
    }

    showEditPickupDetailComponent(show: boolean) {
        if (this._storedDataService.isLocationAndPickupEditionComplete) {
            this._storedDataService.isLocationAndPickupEditionComplete = false;
            this.cancel();
        } else {
            this.showEditLocationDetails = !show;
            this.showEditPickupDetails = show;
        }

    }

    openErrorMessageServerModal() {
        this.errorServerMessage.open();
    }

    closeErrorMessageServerModal() {
        this.errorServerMessage.close();
    }

    CallingLocationServices() {
        this.isLoading = true;
        this.errors.forEach(element => {
            if (this.errors[element].id === 'stringAddress') {
                this.errors.splice(element, 1);
            }
        });

        // Get Available Days and Services
        // Call API for Available Days and Services
        let url = this._commonService.createURL(ServiceURLConstants.GET_UPPLM_PICKUP_DETAILS, ApiErrorCode.GET_UPPLM_PICKUP_DETAILS);
        this._apiService.PostServiceAPI(url, this.createAvailableItemsRequest()).subscribe((response: PickupScheduleDetailResponse) => {
            if (response.errors) {
                this.isLoading = false;
                this.getAvailableServicesErrors(response.errors);
            } else {
                this.availableDaysAndServices = response.availableDaysAndServices;
                this.storeDataInSession();
                // Prepare request to save location data
                this._storedDataService.requestEditedData = this._locationDetailsHelperService.prepareSaveEditionRequest(
                    this.editedAddress, this._storedDataService.locationDetailsTransitSession.companyName);
                // Validate for changes the schedule
                if (this.isValidSchedule()) {
                    // Hide Edit Location Detail Window
                    this.showNotificationComponent(true);
                } else { // There's difference in pickups, so redirect to Pickup details
                    this._storedDataService.pickupDetails.pickupScheduleDetailResponse = new PickupScheduleDetailResponse();
                    this._storedDataService.pickupDetails.pickupScheduleDetailResponse.pickupPlanTypes = response.pickupPlanTypes.filter(x => x.validType !== false);
                    this._storedDataService.pickupDetails.pickupScheduleDetailResponse.errors = response.errors;
                    this._storedDataService.pickupDetails.pickupScheduleDetailResponse.availableDaysAndServices = this.availableDaysAndServices;
                    this._storedDataService.pickupDetails.pickupType = this._pickupDetailsHelperService.getPickupTypeSelection(
                        this._storedDataService.pickupDetails.pickupType);
                    this._storedDataService.pickupDetails.pickupComesFromLocation = true;
                    this.showEditPickupDetailComponent(true);
                }
            }
            this.isLoading = false;
        });
    }

    createAvailableItemsRequest(): GetPickupScheduleDetailsRequest {
        let availableItemsRequest = new GetPickupScheduleDetailsRequest();
        availableItemsRequest.address.AddressLine1 = this.editedAddress.address1;
        availableItemsRequest.address.CityTown = this.editedAddress.city;
        availableItemsRequest.address.StateProvince = this.editedAddress.state.key;
        availableItemsRequest.address.CountryCode = this.editedAddress.country.key;
        availableItemsRequest.address.PostalCode = this.editedAddress.postal;
        availableItemsRequest.clientKey = this._storedDataService.locationDetails.clientKey;
        availableItemsRequest.preferredOptions.pickupPlanTypeSelected.pickupPlanType = this._pickupDetailsHelperService.getPickupTypeSelection(this._storedDataService.pickupDetails.pickupType);
        availableItemsRequest.preferredOptions.availableDaysAndServicesSelected =
            this._pickupDetailsHelperService.getPreferredServicesFromSelectedDays(this._storedDataService.pickupDetails.selectedDays);
        return availableItemsRequest;
    }

    isValidSchedule(): boolean {
        //Validate New Schedule
        if (this.availableDaysAndServices.some(elem => elem.validTime === false)) return false;
        return true;
    }

    getAvailableServicesErrors(errors: any[]) {
        // No service Available
        if (errors.filter(x => x.code !== '10008')) {
            const addressInvalid = [{
                "id": "stringAddress",
                "displayText": this._translate.transform('upplm.locationdetails.error.notablereceivepickups'),
                "type": "info",
                "fieldName": "Invalid Addresss error",
                "fieldError": "Invalid Addresss error",
                "fieldErrorDescription": "field Error"
            }
            ];
            this.errors = this.errors.concat(addressInvalid);
        }
        //Any other Error, Display modal
        if (errors[0].message !== '' || errors[0].message !== null) {
            this.messagesErrorServer = errors[0].message;
        }
    }
}